import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter, useLocation } from 'react-router-dom'
import App from './App'
import './styles/globals.css'
import I18nInitializer from '@/components/I18nInitializer'
import { AppProviders } from '@/components/providers/AppProviders'
import ClientHeader from '@/components/layout/ClientHeader'
import ConditionalFooter from '@/components/layout/ConditionalFooter'
import { CookieConsentBanner } from '@/components/ui'

document.documentElement.style.setProperty('--font-inter', "'Inter', ui-sans-serif, system-ui, sans-serif")
document.documentElement.style.setProperty('--font-poppins', "'Poppins', ui-sans-serif, system-ui, sans-serif")

function RootShell() {
  const { pathname } = useLocation()
  const isAdminRoute = pathname.startsWith('/admin')

  return (
    <AppProviders>
      <ClientHeader />
      <main className={isAdminRoute ? 'min-h-screen' : 'pt-16 min-h-screen'}>
        <App />
      </main>
      <ConditionalFooter />
      <CookieConsentBanner />
    </AppProviders>
  )
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <I18nInitializer />
      <RootShell />
    </BrowserRouter>
  </React.StrictMode>
)
